import { Button, ButtonProps, Carousel, Image } from "antd";
import { CustomPhotosItem } from "../types/file.type";
import React from "react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import styled from "styled-components";

interface ListingImagePreviewProps {
	photos?: (CustomPhotosItem | {error: any})[];
}

const ListingImagePreview: React.FC<ListingImagePreviewProps> = ({ photos }) => {
	return (
		<Carousel
			variableWidth={true}
			infinite={false}
			dots={false}
			focusOnSelect={true}
			arrows
			draggable
			className="listing-preview"
			nextArrow={
				<CarouselButton>
					<ArrowRightOutlined />
				</CarouselButton>
			}
			prevArrow={
				<CarouselButton>
					<ArrowLeftOutlined />
				</CarouselButton>
			}
		>
			{photos
				?.filter((item) => item && (item as CustomPhotosItem).url)
				?.map((item) => (
					<Image
						key={(item as CustomPhotosItem).key || ''}
						src={(item as CustomPhotosItem).url || ''}
						height={200}
						width={200}
						className="image-cover-fit"
					/>
				))}
		</Carousel>
	);
};

const CarouselButton: React.FC<{ currentSlide?: number; slideCount?: number } & ButtonProps> = ({
	currentSlide,
	slideCount,
	...props
}) => {
	return <ArrowButton {...props} />;
};

const ArrowButton = styled(Button)`
	display: block;
	* {
		color: ${({ theme }) => theme.colors.white};
		display: block;
		width: 20px;
		height: 20px;
	}
`;

export default ListingImagePreview;
